export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.20ea693c.woff";